import {
    FETCH_MEDICLAIM_DETAILS_REQUEST,
      FETCH_MEDICLAIM_DETAILS_SUCCESS,
      FETCH_MEDICLAIM_DETAILS_FAILURE,
    } from "./FetchMediclaimDetailsTypes";
    import api from "../../utils/Api";
    
    export const fetchMediclaimDetailsRequest = () => {
      return {
        type: FETCH_MEDICLAIM_DETAILS_REQUEST,
      };
    };
    
    export const fetchMediclaimDetailsSuccess = (mediclaimDetails) => {
      return {
        type: FETCH_MEDICLAIM_DETAILS_SUCCESS,
        payload: mediclaimDetails,
      };
    };
    
    export const fetchMediclaimDetailsFailure = (error) => {
      return {
        type: FETCH_MEDICLAIM_DETAILS_FAILURE,
        payload: error,
      };
    };
    
    export const fetchMediclaimDetailsListing = (mediswitch_transaction_id) => {
      
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      let url = `payment/claimtransaction/detail?mediswitch_transaction_id=`+mediswitch_transaction_id;
    
      
      return async (dispatch) => {
        dispatch(fetchMediclaimDetailsRequest);
        try {
          const response = await api.get(url,
            {
              headers: headers,
            }
          );
          const mediclaimDetails = response.data.data;
          //console.log("initialNotesData", initialNotesData)
          dispatch(fetchMediclaimDetailsSuccess(mediclaimDetails));
        } catch (error) {
          console.log("Redux error - ", error.response);
          const errorMsg = error.message;
          dispatch(fetchMediclaimDetailsFailure(errorMsg));
        }
      };
    };
    